import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Docs from '/src/data/auto-generated/pwa-buildpack/lib/BuildBus/declare-base.md';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "targets"
    }}>{`Targets`}</h1>
    <p>{`Buildpack's targets follow the same Target API as other packages' targets, but they play a unique role.
Buildpack targets are the fundamental "roots" of the PWA Studio Target system.`}</p>
    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`All other Targets operate by intercepting other Targets.
BuildBus runs the declare and intercept phases by itself.
But nothing `}<em parentName="p">{`calls`}</em>{` targets to run any interceptors until Buildpack begins the process, by directly invoking one of its `}<em parentName="p">{`own`}</em>{` targets.`}</p>
    <p>{`The Buildpack targets are therefore very generic and low-level.
They are meant to be used as building blocks for higher-level feature targets, such as adding routing or navigation logic.`}</p>
    <p>{`Even deeper than Buildpack targets are the very similar Hooks that make up `}<a parentName="p" {...{
        "href": "https://v4.webpack.js.org/api/plugins/"
      }}>{`Webpack's plugin system`}</a>{`.
Interceptors can use Buildpack's `}<inlineCode parentName="p">{`webpackCompiler`}</inlineCode>{` target to acquire a reference to the Webpack Compiler object for each build, and can then do anything a Webpack plugin can do.
Because of their similarity in form and function, the PWA Studio Targets system integrates seamlessly into the larger Webpack ecosystem as a commerce-driven superset of its functionality.`}</p>
    {/*
     The reference doc content is generated automatically from the source code.
     To update this section, update the doc blocks in the source code
     */}

    <Docs mdxType="Docs" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      